export class ColumnistDropdown {
  constructor(select) {
    this.select = select;
    this.btn = select.querySelector('.context-select__btn');
    this.dropdown = select.querySelector('.context-select-dropdown');
    this.textSpan = this.btn.querySelector('span');

    this.init();
  }

  init() {
    this.btn.addEventListener('click', this.handleButtonClick.bind(this));
    document.addEventListener('click', this.handleDocumentClick.bind(this));
  }

  async handleButtonClick(e) {
    e.stopPropagation();

    // Close other open selects
    document.querySelectorAll('.context-select_columnist').forEach(otherSelect => {
      if (otherSelect !== this.select) {
        otherSelect.classList.remove('context-select_active');
        otherSelect.querySelector('.context-select-dropdown').style.display = 'none';
      }
    });

    // Toggle current select
    this.select.classList.toggle('context-select_active');

    if (this.select.classList.contains('context-select_active')) {
      await this.loadCategories();
      this.dropdown.style.display = 'flex';
    } else {
      this.dropdown.style.display = 'none';
    }
  }

  handleDocumentClick() {
    this.select.classList.remove('context-select_active');
    this.dropdown.style.display = 'none';
  }

  async loadCategories() {
    if (!this.dropdown.children.length) {
      try {
        const locale = window.locale === 'uk' ? '' : `/${window.locale}`;
        const response = await fetch(`${locale}/context/get_all_categories/`);
        const html = await response.text();

        // Insert the HTML directly into the dropdown
        this.dropdown.innerHTML = html;

        // Add click handlers to the newly added items
        this.dropdown.querySelectorAll('.context-select-dropdown__item').forEach(item => {
          item.addEventListener('click', () => this.handleItemClick(item));
        });
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    }
  }

  handleItemClick(item) {
    // Remove active class from all items
    this.dropdown.querySelectorAll('.context-select-dropdown__item').forEach(i =>
      i.classList.remove('context-select-dropdown__item_active')
    );

    // Add active class to selected item
    item.classList.add('context-select-dropdown__item_active');

    // Update button text
    this.textSpan.textContent = item.querySelector('.context-select-dropdown__item-text').textContent;

    // Add selected class to select
    this.select.classList.add('context-select_selected');

    // Close dropdown
    this.select.classList.remove('context-select_active');
    this.dropdown.style.display = 'none';
  }
}